export const canchas = [
    { name: "Bahiense del Norte 1" },
    { name: "Bahiense del Norte 2" },
    { name: "Bahiense del Norte 3" },
    { name: "Olimpo 1" },
    { name: "Estrella" },
    { name: "Independiente" },
    { name: "Comercial" },
    { name: "Liniers" },
    { name: "9 de Julio" },
    { name: "Argentino" }
];